import { toast } from 'react-toastify';
import store from '../stores';
import { UNSET_USER } from '../stores/auth';
import setAuthToken from './setAuthToken';

let isLoggingOut = false;

const LOGIN_PATH_FRAGMENT = '/company/login/';

export const isLoginRequest = (url = '') => String(url).includes(LOGIN_PATH_FRAGMENT);

export const handleUnauthorized = (requestUrl = '') => {
  if (isLoggingOut || isLoginRequest(requestUrl)) {
    return;
  }

  isLoggingOut = true;
  toast.error('Session expired or unauthorized. Please log in again.', {
    position: 'top-right',
    autoClose: 3000,
  });
  localStorage.clear();
  setAuthToken(false);
  store.dispatch(UNSET_USER());
  window.location.replace(`${window.location.pathname}${window.location.search}#/`);
};
